import type {
  AdminAccountType,
  AdminStudyPermissionAccess,
} from "./adminUsersAccessData";

export type AdminStudyAssignmentUser = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
};

export type AdminStudyAssignment = {
  id: string;
  user: AdminStudyAssignmentUser;
  access: AdminStudyPermissionAccess;
  dateAssigned: string;
};

export type AdminStudyPermissionGroup = {
  id: string;
  studyName: string;
  trialId: string;
  accentColor: string;
  roles: string[];
  assignments: AdminStudyAssignment[];
};

export type AdminAccountHistoryMetadata = {
  user: AdminStudyAssignmentUser;
  email: string;
  studyLabel: string;
  access: AdminStudyPermissionAccess;
  accountType: AdminAccountType;
};

export type AdminAccountHistoryEvent = {
  id: string;
  actor: string;
  action: string;
  timestamp: string;
  user: AdminStudyAssignmentUser;
  studyLabel?: string;
  access?: AdminStudyPermissionAccess;
  accountType?: AdminAccountType;
};

export type AdminAccountHistory = {
  assignmentId: string;
  metadata: AdminAccountHistoryMetadata;
  events: AdminAccountHistoryEvent[];
};

export type AdminRevokeStudyAccessContent = {
  title: string;
  description: string;
  warning: string;
  cancelLabel: string;
  confirmLabel: string;
};

export const adminAccountHistoryByAssignmentId: Record<
  string,
  AdminAccountHistory
> = {
  "lumina-julia-nelson": {
    assignmentId: "lumina-julia-nelson",
    metadata: {
      user: {
        id: "admin-user-009",
        firstName: "Julia",
        lastName: "Nelson",
        email: "jnelson@gmail.com",
      },
      email: "julianelson@gmail.com",
      studyLabel: "DARATU | DEMO_TRIAL",
      access: "full_access",
      accountType: "ADMIN",
    },
    events: [
      {
        id: "julia-added-lumina",
        actor: "Omniscience",
        action: "added user to study",
        timestamp: "2025-12-03 at 2:36 PM",
        user: {
          id: "admin-user-009",
          firstName: "Julia",
          lastName: "Nelson",
          email: "jnelson@gmail.com",
        },
        studyLabel: "LUMINA_AD | DEMO_TRIAL_2",
        access: "full_access",
      },
      {
        id: "julia-added-daratu",
        actor: "Omniscience",
        action: "added user to study",
        timestamp: "2025-12-03 at 2:36 PM",
        user: {
          id: "admin-user-009",
          firstName: "Julia",
          lastName: "Nelson",
          email: "jnelson@gmail.com",
        },
        studyLabel: "DARATU | DEMO_TRIAL",
        access: "full_access",
      },
      {
        id: "julia-invited-admin",
        actor: "Omniscience",
        action: "invited user to Vivo",
        timestamp: "2025-12-03 at 2:36 PM",
        user: {
          id: "admin-user-009",
          firstName: "Julia",
          lastName: "Nelson",
          email: "jnelson@gmail.com",
        },
        accountType: "ADMIN",
      },
    ],
  },
  "daratu-ben-gough": {
    assignmentId: "daratu-ben-gough",
    metadata: {
      user: {
        id: "admin-user-001",
        firstName: "Ben",
        lastName: "Gough",
        email: "bgough@gmail.com",
      },
      email: "bgough@gmail.com",
      studyLabel: "DARATU | DEMO_TRIAL",
      access: "full_access",
      accountType: "USER",
    },
    events: [
      {
        id: "ben-added-daratu",
        actor: "Omniscience",
        action: "added user to study",
        timestamp: "2025-12-03 at 2:36 PM",
        user: {
          id: "admin-user-001",
          firstName: "Ben",
          lastName: "Gough",
          email: "bgough@gmail.com",
        },
        studyLabel: "DARATU | DEMO_TRIAL",
        access: "full_access",
      },
    ],
  },
};

export const adminRevokeStudyAccessContent: AdminRevokeStudyAccessContent = {
  title: "Remove study access",
  description:
    "Are you certain you want to revoke this user's access to the study? They will no longer be able to view it. Administrators can re-add users to a study at any time.",
  warning: "",
  cancelLabel: "Cancel",
  confirmLabel: "Revoke",
};
